import React, {Component} from 'react'
import {Image} from 'react-konva';
import './stage.css';

/** @class ScrollingLayer
 * A ScrollingLayer scrolls a repeating pattern across
 * the stage in a cardinal direction.
 */
export default class ScrollingLayer extends Component {
  /** @constructor
    * Creates a new instance of ScrollingLayer
    */
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      offsetX: 0,
      offsetY: 0
    }
  }
  /** @method componentWillMount
    * Loads the image
    */
  componentWillMount() {
    var image = new window.Image();
    image.onload = () => {
      this.setState({image: image});
    }
    image.src = this.props.image;
  }
  /** @method componentDidMount
    * Starts the image scrolling.
    */
  componentDidMount() {
    this.interval = window.setInterval(()=>{
      const speed = parseFloat(this.props.speed);
      switch(this.props.direction) {
        case 'up':
          return this.setState({
            offsetY: (this.state.offsetY + speed)
          });
        case 'down':
          return this.setState({
            offsetY: (this.state.offsetY - speed)
          });
        case 'right':
          return this.setState({
            offsetX: (this.state.offsetX - speed)
          });
        case 'left':
          return this.setState({
            offsetX: (this.state.offsetX + speed)
          });
        default:
          return null;
      }
    }, 60)
  }
  /** @method componentWillUnmount
    * Clears any active interval.
    */
  componentWillUnmount() {
    window.clearInterval(this.interval);
  }
  /** @function
   * Renders the ScrollingLayer component.
   */
  render() {
    return (
      <Image
        fillPatternImage={this.state.image}
        fillPatternOffsetX={this.state.offsetX}
        fillPatternOffsetY={this.state.offsetY}
        width={this.props.width}
        height={this.props.height}
        repeat="repeat"
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/stage/scrolling-layer.js